export default class UnauthorizedError extends Error {
  constructor() {
    super('Wrong credentials');
    this.name = 'UnauthorizedError';
  }
}
